// react component to show the history of a checklist
import React, { useEffect, useState, useContext } from 'react'
import {
  BrowserRouter as Router,
  Link,
  Navigate,
  useNavigate,
  useParams
} from "react-router-dom"
import { GlobalContext, } from '../GlobalContext'
import Button from '../formfields/Button'
import Card from '../ui-elements/Card'
import { Value } from 'sass'
import SettingsDetails from './SettingsDetails'
import QuestionsDetails from './QuestionsDetails'
import ChecklistWrapper from './wrapper/ChecklistWrapper'
import QuickStartQRDetails from './QuickStartQRDetails'
import UploadResultsSpreadsheet from './UploadResultsSpreadsheet'
import QuestionsMiniSummary from './QuestionsMiniSummary'
import UpdateHistoryItem from '../ui-elements/UpdateHistoryItem'
import Paginate from '../ui-elements/Paginate'
import Spinner from '../ui-elements/Spinner'

type Props = {
}

function ChecklistHistory({
}: Props) {

  const {
    tableData,
    getHistoryForChecklist,
    getQuestionsForChecklist,
    checklistHistories
  } = useContext(GlobalContext)


  const { checklistId } = useParams()
  const [prevUrl, setPrevUrl] = useState(`/checklists/`)
  const [nextUrl, setNextUrl] = useState(`/checklists/${checklistId}/settings/checklist-name`)
  const [savingProgress, setSavingProgress] = useState(false)
  const [questionsData, setQuestionsData] = useState<null | ObjectStringKeyAnyValue>(null)
  const [displayItems, setDisplayItems] = useState<ObjectStringKeyAnyValue>({})
  const checklistHistory = checklistId && checklistHistories[checklistId]
  const checklistName = tableData && checklistId && tableData.Checklists && tableData.Checklists[checklistId] && tableData.Checklists[checklistId].ChecklistName
  const sortedHistoryItemIds = checklistHistory ? Object.keys(checklistHistory).sort((a, b) => {
    const dateA = new Date(checklistHistory[a]['modified_at'])
    const dateB = new Date(checklistHistory[b]['modified_at'])
    return dateB.getTime() - dateA.getTime()
  }) : []

  const arrayStartIndex = displayItems.indexOfFirstItem || 0
  const arrayEndIndex = displayItems.indexOfLastItem || 5
  const arrayToDisplay: any[] = sortedHistoryItemIds && sortedHistoryItemIds.slice(arrayStartIndex, arrayEndIndex)

  useEffect(() => {
    if (checklistId) {
      getHistoryForChecklist(checklistId)
      getQuestionsForChecklist(checklistId)
    }
  }, [checklistId])


  useEffect(() => {
    if (tableData) {
      // save questions 
      const newChecklistQuestions: ObjectStringKeyAnyValue = {}
      for (const questionKey in tableData['ChecklistQuestions']) {
        if (tableData['ChecklistQuestions'][questionKey]['ChecklistId'] === checklistId) {
          newChecklistQuestions[questionKey] = tableData['ChecklistQuestions'][questionKey]
        }
      }
      setQuestionsData(newChecklistQuestions)
    }


  }, [tableData, checklistId])



  return <ChecklistWrapper
    title={'Checklist History'}
    // subtitle={''}
    // prevUrl={prevUrl}
    // nextUrl={nextUrl}
    savingProgress={savingProgress}
    setSavingProgress={setSavingProgress}
  >


    <div className={`flex flex-row gap-4 items-center justify-between mb-4 `}>
      <h3 className={`font-righteous text-3xl font-brandblue`}>
        Revision history for checklist {checklistName ? `"${checklistName}"` : `ID #${checklistId}`}
      </h3>



    </div>

    {!checklistHistory && <Spinner>
      Loading history {checklistName && `For "${checklistName}"...`}
    </Spinner>}


    {sortedHistoryItemIds.length > 0 &&
      <Paginate setDisplayItems={setDisplayItems} itemsPerPage={15} maxPageNumbersToDisplay={10} arrayToPageThrough={sortedHistoryItemIds}>
        {arrayToDisplay.map((key, index) => {
          const historyItem = checklistHistory[key]
          return <UpdateHistoryItem
            key={index}
            historyItem={historyItem}
          />
        })}
      </Paginate>
    }




  </ChecklistWrapper>
}
export default ChecklistHistory